import { BrowserRouter, Route, Routes } from "react-router";
import ViewRetreat from "./pages/retreats/view";
import ViewAllRetreats from "./pages/retreats/view-all";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import NotFound from "./pages/utilities/not-found";
import Login from "./pages/login/login";
import ViewSales from "./pages/sales/view";
import Navbar from "./Navbar";
import Search from "./pages/search/search";


function App() {
	return (
		<>
			<BrowserRouter>
				<Navbar />
				<Routes>
					<Route path="/" element={<ViewAllRetreats />} />
					<Route path="/login" element={<Login />} />
					<Route path="/view/:id" element={<ViewRetreat />} />
					<Route path="/sales" element={<ViewSales />} />
					<Route path="/search" element={<Search />} />
					<Route path="/notfound" element={<NotFound />} />
				</Routes>
			</BrowserRouter>

			<div className="container mx-auto">
				<ToastContainer
					position="top-right"
					theme="colored"
					autoClose={3000}
					hideProgressBar={false}
					newestOnTop={false}
					closeOnClick
					rtl={false}
					pauseOnFocusLoss
					draggable
					pauseOnHover
				/>
			</div>
		</>
	)
}

export default App;